<ion-header>
  <ion-toolbar class="no-background">
    <ion-button (click)="closeModal()" class="cancelbtn" slot="end" fill="clear">
      <ion-icon slot="icon-only" class="icon-color" name="close"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content class="white-background">
  <div *ngFor="let d of previousValue" [ngSwitch]="true" style="padding-left: 15px;
  padding-right: 15px; padding-bottom: 0px; margin-top: 10px;">
      
      <label class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-bottom: 0px;
      font-size: 18px;
      margin-top: 5px;" *ngSwitchCase="d.controlType === 'textbox' || d.controlType === 'select' || d.controlType === 'textarea'">{{d.label[_appSetting.selectedLanguage]}}</label>
      <input class="form-control setbackground" readonly="true" *ngIf="d.controlType == 'label'" name="controlvalue"
      value="{{d.controlvalue}}" />
      <input class="form-control" type="{{d.controlType}}" name="controlvalue"
        value="{{d.controlvalue}}" (change)="setTableCtlVal($event.target,d)"
        *ngSwitchCase="d.controlType == 'textbox'" placeholder="{{d.placeholder}}">
      <textarea class="form-control" name="controlvalue" placeholder="{{d.placeholder}}"
        *ngSwitchCase="d.controlType === 'textarea'" (change)="setTableCtlVal($event.target,d)">
      </textarea>
      <select autocomplete="on" *ngSwitchCase="d.controlType === 'select'" class="form-control"
        (change)="setTableCtlVal($event.target,d)" name="controlvalue">
        <option value=''>Select</option>
        <option *ngFor="let opt of d.controlOptions" [value]="opt.id"
        [selected]="opt.id === d.controlvalue">{{opt.option[_appSetting.selectedLanguage]}}
        </option>
      </select>
</div>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding: 10px">
    <button (click)="getValue()" class="btn btn-primary float-right">{{"common_btn_text.save_btn" | translate}}</button>
  </div>
</ion-content>